// @flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import SearchBar from './SearchBar';
import FiltersBar from './FiltersBar';
import BuildingsResult from './BuildingsResult';
import HomeLayout from '../HomeLayout';


class BuildingsView extends PureComponent {
  static defaultProps = {
    initialQuery: {},
  }

  state = {
    query: {
      ...this.props.initialQuery,
    },
  }

  props: {
    initialQuery: Object,
    title: string,
  }

  handleChangeQuery = (nextQuery: Object) => {
    this.setState({
      query: nextQuery,
    });
  }

  render() {
    return (
      <HomeLayout>
        <SearchBar
          title={this.props.title}
          query={this.state.query}
          onChangeQuery={this.handleChangeQuery}
        />
        <FiltersBar
          query={this.state.query}
          onChangeQuery={this.handleChangeQuery}
        />
        <BuildingsResult
          query={this.state.query}
          onChangeQuery={this.handleChangeQuery}
        />
      </HomeLayout>
    )
  }
}

export default BuildingsView;



// WEBPACK FOOTER //
// ./src/components/BuildingsView/index.js